module.exports = __webpack_public_path__ + "img/login_msal.a63587a7.png";